export * from './platform-no-data-found.module';
export * from './components/no-data-found/no-data-found.component';